// Verfügbare Hintergrund-Ebenen (Basiskarten) der Lageplan-Ansicht. Die IDs stimmen mit den
// erlaubten Werten im Backend überein; `label` ist zugleich der Name der Leaflet-BaseLayer.
export type BasiskarteId = 'LUFTBILD' | 'KARTE' | 'WEISS' | 'SATELLIT';

export const BASISKARTEN: { id: BasiskarteId; label: string }[] = [
  { id: 'LUFTBILD', label: 'Luftbild (LGLN DOP20)' },
  { id: 'KARTE', label: 'Karte' },
  { id: 'WEISS', label: 'Weiß (ohne Karte)' },
  { id: 'SATELLIT', label: 'Satellit (Esri)' },
];

export const DEFAULT_BASISKARTE: BasiskarteId = 'LUFTBILD';
